var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagLithuania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.5651C31.648 19.8319 32 17.9571 32 16C32 14.0428 31.648 12.168 31.0048 10.4348L16 9.04346L0.995188 10.4348C0.352 12.168 0 14.0428 0 16C0 17.9571 0.352 19.8319 0.995188 21.5651L16 22.9565L31.0048 21.5651Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 10.4348C28.7441 4.342 22.8794 0 16 0C9.12055 0 3.25587 4.342 0.995178 10.4348H31.0048Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C22.8794 32 28.7441 27.658 31.0048 21.5652H0.995178C3.25587 27.658 9.12055 32 16 32Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLithuania);
export default __webpack_public_path__ + "static/media/flag_lithuania.37f973bf20f00755b3b1e07df060cf01.svg";
export { ForwardRef as ReactComponent };